import { useReactivateContract } from '@/hooks/useWizard'
import { Check } from '@/icons'
import { Alert, Button } from '@chakra-ui/react'

export const ReactivateContract = ({ insuranceId, callback }: { insuranceId: number, callback: () => void }) => {
    const { mutateAsync: reactivateContract, isLoading: isReactivating, isError } = useReactivateContract()

    const handleReactivateContract = () =>
        reactivateContract(insuranceId)
            .then(() => {
                callback()
            })

    return <>
        <Button
            variant="outline"
            colorScheme="green"
            onClick={handleReactivateContract}
            disabled={isReactivating}
        >
            <Check />
            {isReactivating ? 'Reaktivuji...' : 'Reaktivovat smlouvu'}
        </Button>

        {isError && <Alert colorScheme="red">Při reaktivaci došlo k chybě</Alert>}
    </>
}